/** Return only boolean feature-toggle paths; configuration values are not toggles. */
export function flattenFeatures(value: object, prefix = ''): string[] {
    return Object.entries(value).flatMap(([key, child]) => {
        const path = prefix ? `${prefix}.${key}` : key;
        return typeof child === 'boolean'
            ? [path]
            : typeof child === 'object' && child !== null
              ? flattenFeatures(child, path)
              : [];
    });
}
